import { GuardedColDef } from '../../common/datagrid';
import { AgNumberCellRenderer } from '../../common/datagrid/components/AgNumberCellRenderer';
import { PriceChangeDirection, PricePeriodDto } from '../../common/PricePrgClient';

export type PricePlanRow = {
    productId: number;
    productName: string;
    customProductAttribute1: string;
    country: string;
    priceUnit: string;
    purchaser?: string;
    stock: number | null;
    grossWeight: number;
    netWeight: number;
    boxesPerPallet: number;
    [day: number]: number;
    priceChangeDirections: {
        [day: number]: PriceChangeDirection | undefined;
    };
    updatedBys: {
        [day: number]: string;
    };
    updatedDates: {
        [day: number]: Date;
    };
    saves: {
        [day: number]: number;
        showSaving: {
            [day: number]: boolean;
        };
    };
};

export type BasePriceUI = {
    isEditingBasePrices: boolean;
};

export type UpdatePricePlan = {
    newPrice: number;
    productId: number;
    dayIndex: number;
};

export type PricePlan = {
    productId: number;
    pricePeriods: PricePeriod[];
};

export type PricePeriod = PricePeriodDto & {
    priceToBeSaved?: number;
};

export const dayAmount = 7;

export const pricePlanInitialColumns: GuardedColDef<PricePlanRow>[] = [
    {
        field: 'productId',
        headerName: 'Product id',
        width: 100,
        editable: false
    },
    {
        field: 'productName',
        headerName: 'Product name',
        width: 300,
        editable: false
    },
    {
        field: 'customProductAttribute1',
        headerName: 'EMV',
        width: 60,
        editable: false
    },
    {
        field: 'country',
        headerName: 'Country',
        width: 82,
        editable: false
    },
    {
        field: 'priceUnit',
        headerName: 'Price unit',
        width: 80,
        editable: false
    },
    {
        field: 'purchaser',
        headerName: 'Purchaser',
        width: 120,
        editable: false
    },
    {
        field: 'stock',
        headerName: 'Stock',
        width: 80,
        cellRenderer: AgNumberCellRenderer,
        editable: false
    },
    {
        field: 'grossWeight',
        headerName: 'Gross weight',
        width: 110,
        cellRenderer: AgNumberCellRenderer,
        editable: false
    },
    {
        field: 'netWeight',
        headerName: 'Net weight',
        width: 110,
        cellRenderer: AgNumberCellRenderer,
        editable: false
    },
    {
        field: 'boxesPerPallet',
        headerName: 'Boxes per pallet',
        width: 80,
        cellRenderer: AgNumberCellRenderer,
        editable: false
    }
];
